<template>
	<div class="footnote-text">
		{{ labels.foot_note.biggest_outlet_explanation }}
		<br />
		{{ labels.foot_note.more_information }}
		<a :href="auszeichnungenLink" target="_blank" rel="noopener">{{ auszeichnungenLink }}</a>
	</div>
</template>

<script>
import { contextPath } from "@ocm/services/ocm-object";
import labels from "../labels.json";

export default {
	data() {
		return {
			labels,
		};
	},
	computed: {
		auszeichnungenLink: () => `${window.location.origin}${contextPath}/auszeichnungen/`,
	},
};
</script>

<style lang="scss" scoped>
.footnote-text {
	color: $color-gray-darker;
	font-size: $fontsize-2xs;
	line-height: 1.2;
	overflow-wrap: break-word;

	a {
		text-decoration: underline;
	}
}
</style>
